<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
    <mat-card-content class="mat-mdc-card-content text-center">
        <div *ngIf="ContractsList?.length==0;then NoContracts else Contracts"></div>

        <ng-template #NoContracts>
            <div class="col-md-12">
                <p> {{ 'NoDataFound' | translate }}</p>
            </div>
        </ng-template>

        <ng-template #Contracts>
            <div class="row">
                <div class="col-md-4" *ngFor="let contract of ContractsList">
                    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                        <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                            <mat-card-title class="mat-mdc-card-title text-white">
                                {{ contract.clientName| subString:20}}
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="mat-mdc-card-content text-center">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table w-100">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <i-tabler name="map-pins" class="icon-15 d-flex icon"></i-tabler>
                                                </td>
                                                <td><span class="span-title">{{ 'Address' | translate }} </span>
                                                </td>
                                                <td><span>{{ contract.address | subString:20 }}</span></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <i-tabler name="Phone" class="icon-15 d-flex icon"></i-tabler>
                                                </td>
                                                <td><span class="span-title">{{ 'Phone' | translate }}</span></td>
                                                <td><span> {{ contract.phone }}</span></td>
                                            </tr>
                                            <tr class="trProducts">
                                                <td>
                                                    <span class="title">{{ 'Products' | translate }}</span>
                                                </td>
                                                <td>
                                                    <div *ngFor="let product of contract.listItem;let i=index">
                                                        <span>{{i+1}} - {{ product.productName }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <mat-divider></mat-divider>
                                            <tr class="trBtn">
                                                <td>
                                                    <a (click)="ChooseContract(contract)" class="btnCreateContract">
                                                        {{ 'ChooseContract' | translate}}
                                                    </a>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </ng-template>
    </mat-card-content>
</mat-card>